import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Single Parents Meet',
  favIconName: 'favicon-single-parent-meet',
  name: 'singleparentmeet',
  facebookUrl: '/cp/social/r/facebook.html?lid=4',
  instagramUrl: '/cp/social/r/instagram.html?lid=4',
  twitterUrl: '/cp/social/r/twitter.html?lid=4',
};

export default branding;
